import { createAction } from '@reduxjs/toolkit';

export const userLogout = createAction('userSession/logout');

export const flushSessionData = createAction('activeSession/flush');
